import { useEffect, useState } from 'react';
import { placess, appeal } from '../../../data';
import { useTranslation } from 'react-i18next';
import {
    ArrowDropDown, Edit, Email,
    FileUpload, Home, MessageOutlined,
    PersonOutline, Phone
}
    from '@mui/icons-material';
import Loading from '../../loader/loader';

const Physical = ({
    data, setData,
    handlePost,
    isLoading
}) => {
    const { t } = useTranslation();
    const [showVelayatDropdown, setShowVelayatDropdown] = useState(false);
    const [showEtrapDropdown, setShowEtrapDropdown] = useState(false);
    const [showAppealDropdown, setShowAppealDropdown] = useState(false);
    const [etrapOptions, setEtrapOptions] = useState([]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setData({ ...data, attachment: file ? file : null});
    };

    const handlePhoneNumberChange = (e) => {
        let input = e.target.value;
        if (!input.startsWith('+993')) {
            input = '+993' + input.replace(/[^0-9]/g, '');
        } else {
            input = '+993' + input.slice(4).replace(/[^0-9]/g, '');
        }
        if (input.length > 12) {
            input = input.slice(0, 12);
        }
        setData({ ...data, phone_number: input });
    };

    const handleVelayatSelect = (velayat) => {
        setData({...data, province: velayat.title, district: ''});
        setEtrapOptions(velayat.content);
        setShowVelayatDropdown(false);
    };

    const handleEtrapSelect = (etrap) => {
        setData({ ...data, district: etrap.name });
        setShowEtrapDropdown(false);
    };

    const handleAppealSelect = (appealItem) => {
        setData({ ...data, request_type: appealItem.name });
        setShowAppealDropdown(false);
    };

    const buttonColor = 
            !data.province || 
            !data.district || 
            !data.request_type || 
            !data.first_name || 
            !data.last_name || 
            !data.patronimic || 
            !data.address || 
            !data.email || 
            !data.message ||
            !data.attachment ||
            !data.phone_number ? 
            'bg-primary' : 'bg-green';

    useEffect(() => {
        if (data.requester_type === 'individual') {
            handlePost(new Event('submit'));
        }
    }, [data.requester_type]);

    const isFormValid = () => {
        return (
            data.province &&
            data.district &&
            data.request_type &&
            data.first_name &&
            data.last_name &&
            data.patronimic &&
            data.address &&
            data.email &&
            data.message &&
            data.attachment &&
            data.phone_number 
        );
    };
    const handleRequesterPost = () => {
        if (!isFormValid()) {
            alert(t('all_must'));
            return;
        }
        setData({
            ...data,
            requester_type: 'individual',
        });
        alert(t('appeal_success'));
    };
    

    return (
        <form>
            <div className="mb-4 lg:flex justify-between gap-8">
                {/* Velayat Selection */}
                <div className="lg:w-[50%] relative">
                    <div className='relative'>
                        <input
                            type="text"
                            name="velayat"
                            value={data.province}
                            placeholder={t('select_province')}
                            readOnly
                            className="w-full px-4 py-2 border border-border rounded 
                                       bg-secondary dark:bg-dark-box dark:border-dark-border 
                                       focus:outline-none focus:ring-2 mb-2 cursor-pointer
                                       focus:ring-indigo-500 dark:text-white"
                            onClick={() => setShowVelayatDropdown(!showVelayatDropdown)}
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showVelayatDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full 
                                        border z-10 max-h-64 overflow-y-auto
                                        dark:bg-dark-box shadow-lg  border-secondary
                                        dark:border-dark-border dark:text-dark-text
                                        p-2 rounded-md input-table bg-white ">
                            {placess.map((velayat) => (
                                <div
                                    key={velayat.id}
                                    onClick={() => handleVelayatSelect(velayat)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {velayat.title}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Etrap Selection */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <div className='relative'>
                        <input
                            type="text"
                            name="etrap"
                            value={data.district}
                            placeholder={t('select_county')}
                            readOnly
                            className="w-full px-4 py-2 border border-border 
                                       bg-secondary rounded cursor-pointer
                                       focus:outline-none focus:ring-2 mb-2
                                       focus:ring-indigo-500 dark:text-white
                                       dark:bg-dark-box dark:border-dark-border"
                            onClick={() => data.province &&
                                setShowEtrapDropdown(!showEtrapDropdown)
                            }
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showEtrapDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full 
                                        border z-10 max-h-64 overflow-y-auto
                                        dark:bg-dark-box shadow-lg  border-secondary
                                        dark:border-dark-border dark:text-dark-text
                                        p-2 rounded-md input-table bg-white ">
                            {etrapOptions.map((etrap, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleEtrapSelect(etrap)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {etrap.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* second row */}
            <div className="mb-4 lg:flex justify-between gap-8">
                {/* Appeal Selection */}
                <div className="lg:w-[50%] relative">
                    <label className='flex items-center gap-1 text-sm 
                                      dark:text-dark-text'>
                        <Edit style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('appeal_type')}
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            name="appeal"
                            value={data.request_type}
                            placeholder={t('appeal_type')}
                            readOnly
                            className="w-full px-4 py-2 border border-border bg-secondary 
                                       rounded cursor-pointer focus:outline-none 
                                       focus:ring-2 focus:ring-indigo-500 mt-1 mb-2
                                       dark:bg-dark-box dark:border-dark-border
                                       dark:text-white"
                            onClick={() => setShowAppealDropdown(!showAppealDropdown)}
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showAppealDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                                        border z-10 max-h-64 overflow-y-auto
                                        dark:bg-dark-box shadow-lg  border-secondary
                                        dark:border-dark-border dark:text-dark-text
                                        p-2 rounded-md input-table">
                            {appeal.map((appealItem) => (
                                <div
                                    key={appealItem.id}
                                    onClick={() => handleAppealSelect(appealItem)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {appealItem.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Name Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <PersonOutline style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_name')}
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={data.first_name}
                        onChange={e => setData({ ...data, first_name: e.target.value })}
                        placeholder={t('write_name')}
                        className="w-full px-4 py-2 border mt-1 mb-2
                                   border-border bg-secondary rounded
                                   focus:outline-none focus:ring-2 
                                   focus:ring-indigo-500 dark:text-white
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            {/* third row */}
            <div className="mb-4 lg:flex justify-between gap-8">
                {/* Surname Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <PersonOutline style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_surname')}
                    </label>
                    <input
                        type="text"
                        name="surname"
                        value={data.last_name}
                        onChange={(e) => setData({ ...data, last_name: e.target.value })}
                        placeholder={t('write_surname')}
                        className="px-4 py-2 border border-border 
                                   bg-secondary rounded w-full mt-1
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>

                {/* Third-name Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <PersonOutline style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_patronymic')}
                    </label>
                    <input
                        type="text"
                        name="third_name"
                        placeholder={t('write_patronymic')}
                        value={data.patronimic}
                        onChange={(e) => setData({ ...data, patronimic: e.target.value })}
                        className="w-full px-4 py-2 border mt-1
                                   border-border bg-secondary mb-2
                                   rounded  focus:outline-none focus:ring-2 
                                   focus:ring-indigo-500 dark:text-white
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            {/* four row */}
            <div className="mb-4 lg:flex justify-between gap-8">
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Email style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('Email')}
                    </label>
                    <input
                        type="text"
                        name="email"
                        placeholder={t('Email')}
                        value={data.email}
                        onChange={(e) => setData({ ...data, email: e.target.value })}
                        className="px-4 py-2 border border-border 
                                   bg-secondary rounded w-full mt-1
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>

                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Home style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_address')}
                    </label>
                    <input
                        type="text"
                        name="phone"
                        placeholder={t('write_address')}
                        value={data.address}
                        onChange={(e) => setData({ ...data, address: e.target.value })}
                        className="w-full px-4 py-2 border mt-1
                                   border-border bg-secondary mb-2
                                   rounded focus:outline-none focus:ring-2 
                                   focus:ring-indigo-500 dark:text-white
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            {/* fifth row */}
            <div className="mb-4">
                <label className='flex items-center gap-1 text-sm
                                  dark:text-dark-text'>
                    <MessageOutlined style={{ fontSize: '18px', color: '#0039a6' }} />
                    {t('your_message')}
                </label>
                <textarea
                    type="text"
                    name="email"
                    placeholder={t('your_message')}
                    value={data.message}
                    onChange={(e) => setData({ ...data, message: e.target.value })}
                    className="px-4 py-2 border border-border mt-1
                               h-40 bg-secondary rounded w-full 
                               focus:outline-none focus:ring-2 mb-2
                               focus:ring-indigo-500 dark:text-white
                               dark:bg-dark-box dark:border-dark-border"
                />
            </div>

            {/* six row */}
            <div className="mb-4 lg:flex justify-between gap-8 items-end">
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <div className='text-sm text-dark-border 
                                    dark:text-dark-text'>
                        {t('attach_file')} :
                        (doc, docx, jpg, pdf, rtf, txt, odt, zip, rar,
                        png, tiff, jpeg, mp4, avi, mov, mp3, wav)
                    </div>

                    <input
                        type="file"
                        id="file-upload"
                        className="hidden"
                        onChange={handleFileChange} 
                    />
                    <label
                        htmlFor="file-upload"
                        className="w-max flex items-center justify-center 
                                   px-4 py-2 bg-indigo-600 text-white mt-2
                                   rounded-md shadow-md cursor-pointer 
                                   transition-all duration-300 bg-primary"
                    >
                        <FileUpload className="mr-2" />
                        {t('choose_file')}
                    </label>

                    {data.attachment &&
                        <div className="mt-2 text-sm text-dark-border
                                        dark:text-dark-text">
                            {t('chosen')} : {data.attachment.name}
                        </div>
                    }
                </div>

                <div className="lg:w-[40%] relative mt-6 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Phone style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('phone_number')}
                    </label>
                    <input
                        type="text"
                        name="phone"
                        placeholder={t('phone_number')}
                        value={data.phone_number}
                        onChange={handlePhoneNumberChange}
                        className="w-full px-4 py-2 border dark:text-dark-text
                                 border-border bg-secondary mb-2 mt-1 rounded 
                                   focus:outline-none focus:ring-2 focus:ring-indigo-500
                                 dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            <div className='w-full flex'>
            {isLoading ? <Loading/> :  
               <button
                    type="button"
                    className={`${buttonColor} text-white px-6 
                                py-2 mt-8 rounded ml-auto`}
                    onClick={() => {
                        handleRequesterPost();
                    }}
                >
                    {t('send')}
                </button>
            }
            </div>
        </form>
    );
};

export default Physical;
